import React, { useContext } from "react";
import VGaurdLogo from "../../../assets/images/logoLogin.svg";
import LoginBanner from "../../../assets/images/loginBanner.svg";
import loginItemConstant from "../../../constants/contentFile.json";
import CheckBox from "../../../assets/images/checkBox.svg";
import TextInput from "../../../components/TextInputComponent/TextInput";
import Button from "../../../components/ButtonComponent/Button";
import "./loginPage.css";
import EyeVisible from "../../../assets/images/eyeVisible.svg";
import EyeInVisible from "../../../assets/images/eyeInVisible.svg";
import { LoginEmailPasswordContext } from "../LoginView";
import CheckBoxFill from "../../../assets/images/checkBoxFill.svg";
import { Col, Row } from "react-bootstrap";
import AlertBox from "../../../components/AlertComponent/AlertBox";
import { Link } from "react-router-dom";
import RouteConstants from "../../../constants/routesContent.json";
const LoginPage = ({ textContents }) => {
  const {
    submitLogin,
    emailId,
    password,
    setEmailID,
    setPassword,
    passwordType,
    setPasswordType,
    invalidEmail,
    invalidPassword,
    remberMeEnable,
    setRemberMeEnable,
    logout,
    showAlert,
    alertMessage,
    setShowAlert,
    statusCode,
    handleAlertSubmit,
  } = useContext(LoginEmailPasswordContext);

  return (
    <>
      <AlertBox
        alertMessage={alertMessage}
        show={showAlert}
        setShow={setShowAlert}
        handleSubmit={
          statusCode == 401
            ? () => {
                logout();
                handleAlertSubmit();
              }
            : () => handleAlertSubmit()
        }
      />
      <Row>
        <Col lg={6} className="loginDiv">
          <div className="loginMainContainer">
            <div className="vgaurdLogo">
              <img src={VGaurdLogo} />
            </div>
            <div className="loginAccountContainer">
              <div className="colwelcome">
                <div className="row align-self-start welcomebackText">
                  {textContents.welcomeBack}
                </div>
                <div className="row align-self-start loginAcountText">
                  {textContents.loginToYourAccount}
                </div>
              </div>
            </div>

            <form className="itemformsection">
              <div className="form-group">
                <label className="row align-self-start emailText">
                  {textContents.email}
                </label>
                <div className="emailInput">
                  <TextInput
                    placeholder={textContents.email}
                    type="text"
                    value={emailId}
                    onChange={(e) => {
                      setEmailID(e.target.value);
                    }}
                  />
                  {invalidEmail ? (
                    <div className="invalid-text">
                      {textContents.emailWarning}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="form-group">
                <label className="row align-self-start passwordText">
                  {textContents.password}
                </label>
                <div className="emailInput">
                  <TextInput
                    placeholder={textContents.password}
                    type={passwordType}
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                  />
                  {invalidPassword ? (
                    <div className="invalid-text">
                      {textContents.passwordWarning}
                    </div>
                  ) : (
                    ""
                  )}
                  {passwordType === "password" ? (
                    <i className="bi bi-eye-slash">
                      <img
                        src={EyeInVisible}
                        onClick={() => {
                          setPasswordType("text");
                        }}
                      />
                    </i>
                  ) : (
                    <i className="bi bi-eye-slash">
                      <img
                        src={EyeVisible}
                        onClick={() => {
                          setPasswordType("password");
                        }}
                      />
                    </i>
                  )}
                </div>
                <div>
                  <div className="d-flex mb-3">
                    <div
                      className="p-1"
                      onClick={() => setRemberMeEnable(!remberMeEnable)}
                    >
                      {remberMeEnable ? (
                        <img src={CheckBoxFill} />
                      ) : (
                        <img src={CheckBox} />
                      )}
                    </div>
                    <div className="p-1 remeberlabel">
                      {textContents.rememberMe}
                    </div>
                    <div className="ms-auto p-2 forgetpwdlabel">
                      <Link
                        to={RouteConstants.FORGOT_PASSWORD}
                        style={{ color: "#afafaf" }}
                      >
                        {textContents.forgotPassword}?
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <Button
                className="buttonLogin"
                text="LOGIN"
                onClick={() => {
                  submitLogin();
                }}
              />
            </form>
          </div>
        </Col>
        <Col lg={6} className="loginBannerDiv">
          <img className="loginBannerImg" src={LoginBanner} />
        </Col>
      </Row>
    </>
  );
};
export default LoginPage;
